import { render, staticRenderFns } from "./JapFollow.vue?vue&type=template&id=e4b1eef4"
import script from "./JapFollow.vue?vue&type=script&lang=js"
export * from "./JapFollow.vue?vue&type=script&lang=js"
import style0 from "./JapFollow.vue?vue&type=style&index=0&id=e4b1eef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports